
webpack.register(
    'modules/right-rail/rolex-clock/rolex-clock',
    function() {
        return import('modules/right-rail/rolex-clock/rolex-clock');
    },
    true
);